const getDataType = function (type_in) {
    let dataType = "DELIVERED";
    let spendDataType = 'DELIVERED_SPEND';
    type_in = type_in.toLowerCase();
    if (type_in.indexOf('gas') !== -1) {
        dataType += '_GAS'
        spendDataType = 'DELIVERED_GAS_SPEND'
    }
    if (type_in.indexOf('gas_energy') !== -1) {
        dataType += 'GAS_ENERGY_DELIVERED'
        spendDataType = 'GAS_ENERGY_DELIVERED_SPEND'
    }
    if (type_in.indexOf('water') !== -1) {
        dataType += '_WATER'
        spendDataType = 'DELIVERED_WATER_SPEND'
    }
    if (type_in.indexOf('hot') !== -1) {
        dataType += '_HOT'
        spendDataType = 'DELIVERED_WATER_HOT_SPEND'
    }
    if (type_in.indexOf('generated') !== -1) {
        dataType = 'GENERATED_DELIVERED';
        spendDataType = 'GENERATED_DELIVERED_SPEND';
    }
    if (type_in.indexOf('export') !== -1) {
        dataType = 'EXPORTED_DELIVERED';
        spendDataType = 'EXPORTED_DELIVERED_SPEND';
    }
    return {
        dataType: dataType,
        spendDataType: spendDataType
    }
}

export default getDataType;